/**
 * Resolves relative paths (e.g., "./", "../") to absolute paths.
 * Next.js Link component does not automatically resolve relative paths,
 * so this utility helps during the React Router DOM to Next.js migration.
 */
export function resolveRelativePath(href: string, currentPathname: string): string {
  if (!href || href.startsWith('/') || href.startsWith('http')) {
    return href;
  }

  const basePath = currentPathname.replace(/\/$/, '');

  if (href.startsWith('./')) {
    return `${basePath}/${href.slice(2)}`;
  }

  if (href.startsWith('../')) {
    const segments = basePath.split('/');
    const hrefSegments = href.split('/');
    for (const segment of hrefSegments) {
      if (segment === '..') {
        segments.pop();
      } else if (segment !== '.' && segment !== '') {
        segments.push(segment);
      }
    }
    return segments.join('/') || '/';
  }

  return href;
}
